import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a189e88"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold"} }, "基本信息", -1))
const _hoisted_2 = { style: {"margin":"10px 0"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold"} }, "其他信息", -1))
const _hoisted_4 = { style: {"margin":"10px 0 10px 30px"} }
const _hoisted_5 = {
  key: 0,
  style: {"font-size":"14px","color":"#c0c4cc","margin-right":"10px","text-align":"center","width":"20px"}
}
const _hoisted_6 = {
  key: 2,
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"16px","margin":"0 8px"} }, "——", -1))

import { withDefaults, ref, onMounted } from 'vue';
import {
  BaseDialog,
  BaseRow,
  BaseCol,
  BaseButton,
  BaseCheckbox,
  BaseCheckboxGroup,
  BaseTooltip,
  BaseInput,
  BaseDatePicker,
  BaseSelect,
  BaseCascader,
  BaseAutocomplete,
  XrkMessage,
  BaseAlert
} from 'xrk-components';
import { getDisplayInfo } from '../data-source/apis';
import { storage } from '@/utils/storage';
import { getColumnsCheckedKey } from '@/components/biz/biz-table-set-field/src/hooks';


export default /*#__PURE__*/_defineComponent({
  __name: 'set-display-info',
  props: {
    projectId: {},
    projectType: {},
    remove: {}
  },
  emits: ['confirm'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

//基本信息
const basic = ref<boolean>(false); //默认是否全选
const checkedBasic = ref([]); //选取的基本信息list
const basicList = ref([]); //用做渲染基本信息控件的list

//其他信息
const other = ref<boolean>(false); //默认是否全选
const checkedOther = ref([]);
const otherList = ref([]);

const storeKey = getColumnsCheckedKey(props.projectId + '_task-auto-check');

const limitToNum = data => {
  let num = data
    .replace(/[^\d.-]/g, '')
    //只允许一个小数点
    .replace(/^\./g, '')
    .replace(/\.{2,}/g, '.')
    //只能输入小数点后两位
    .replace('.', '$#$')
    .replace(/\./g, '')
    .replace('$#$', '.')
    // eslint-disable-next-line no-useless-escape
    .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
  return num;
};

const clearCheck = (e, i, list) => {
  if (!e) {
    const map = {
      basicList: basicList.value,
      otherList: otherList.value
    };
    map[list][i].conditionKey = '';
  }
};

const searchRule = list => {
  let ruleError = list.find(item => {
    if (+item.dataType === 8 && Array.isArray(item.conditionKey)) {
      //因为区间搜索需要全部填或者全部不填
      //所以判断第一个字段没有值并且第二个字段有值返回 error
      if (!item.conditionKey[0] && item.conditionKey[1]) {
        XrkMessage.error('请填写正确的数字区间');
        return item;
      } else if (!item.conditionKey[1] && item.conditionKey[0]) {
        XrkMessage.error('请填写正确的数字区间');
        return item;
      } else if (isNaN(+item.conditionKey[0]) || isNaN(+item.conditionKey[1])) {
        XrkMessage.error('请填写正确的数字区间');
        return item;
      } else if (+item.conditionKey[0] > +item.conditionKey[1]) {
        XrkMessage.error('请填写正确的数字区间');
        return item;
      }
    }
  });
  if (ruleError) {
    return false;
  } else {
    return true;
  }
};

//基本信息全选
const basicCheckAll = val => {
  const basicCheckAllList = basicList.value.map((item, index) => {
    clearCheck(val, index, 'basicList');
    return 'basic' + item.prop;
  });
  checkedBasic.value = val ? basicCheckAllList : [];
};

const basicChecked = value => {
  basic.value = value.length === basicList.value.length;
};
//其他信息全选
const otherCheckAll = val => {
  const otherCheckAllList = otherList.value.map((item, index) => {
    clearCheck(val, index, 'otherList');
    return 'other' + item.prop;
  });
  checkedOther.value = val ? otherCheckAllList : [];
};
const otherChecked = value => {
  other.value = value.length === otherList.value.length;
};

//查看项目是否有缓存数据
const taskCheck = () => {
  const isCache = storage.get(storeKey);
  if (isCache) {
    // 如果有缓存
    checkedBasic.value = JSON.parse(isCache).checkedBasic;
    checkedOther.value = JSON.parse(isCache).checkedOther;

    other.value = checkedOther.value.length === otherList.value.length; //其他信息全选按钮
    basic.value = checkedBasic.value.length === basicList.value.length; //基本信息全选按钮
  }
  // else {
  //   otherCheckAll(true); //其他默认信息全选
  //   checkedBasic.value = ['basicfullName', 'basicphone']; //基本信息默认选中人员和电话
  // }
};

// const clearAll = () => {
//   basicList.value.forEach(item => {
//     if (checkedBasic.value.indexOf('basic' + item.prop) === -1) {
//       item.conditionKey = null;
//     }
//   });
//   otherList.value.forEach(item => {
//     if (checkedOther.value.indexOf('other' + item.prop) === -1) {
//       item.conditionKey = null;
//     }
//   });
// };

const save = () => {
  //所选项条数
  const isSelectNum = checkedBasic.value.length + checkedOther.value.length;
  if (isSelectNum < 1) {
    XrkMessage.error('至少选择一项展示');
    return;
  }
  //筛选选中的数据
  const basicCheckedList = basicList.value.filter(item => {
    return checkedBasic.value.indexOf('basic' + item.prop) !== -1;
  });
  const otherCheckedList = otherList.value.filter(item => {
    return checkedOther.value.indexOf('other' + item.prop) !== -1;
  });
  const list = [...basicCheckedList, ...otherCheckedList];
  //数字区间校验
  if (!searchRule(list)) {
    return;
  }
  const cacheCheck = {
    checkedBasic: [...checkedBasic.value],
    checkedOther: [...checkedOther.value]
  };
  //储存快捷审核需要的表头信息
  sessionStorage.setItem('quickCheckedList', JSON.stringify(list));
  //根据id储存快捷审核所选内容
  storage.set(storeKey, JSON.stringify(cacheCheck));
  emits('confirm');
  props.remove();
};

onMounted(() => {
  getDisplayInfo({
    projectId: props.projectId,
    sceneType: props.projectType
  }).then(res => {
    basicList.value = res.data.baseInfos.map(item => {
      return { ...item, conditionKey: '' };
    });
    otherList.value = res.data.generalExtendInfos.map(item => {
      return { ...item, options: JSON.parse(item.options), conditionKey: '' };
    });
    taskCheck();
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    center: "",
    title: "设置展示信息",
    width: "870px",
    "model-value": true,
    "before-close": props.remove,
    "close-on-press-escape": true
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: props.remove
      }, {
        default: _withCtx(() => [
          _createTextVNode("取 消")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_unref(BaseButton), {
        type: "primary",
        onClick: save
      }, {
        default: _withCtx(() => [
          _createTextVNode("确 定")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BaseRow), { style: {"padding":"20px"} }, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseCol), { span: 12 }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(BaseCheckbox), {
                  modelValue: basic.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((basic).value = $event)),
                  onChange: basicCheckAll
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 全选 ")
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createVNode(_unref(BaseCheckboxGroup), {
                modelValue: checkedBasic.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((checkedBasic).value = $event)),
                onChange: basicChecked
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(basicList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      style: {"display":"flex","align-items":"center","margin-bottom":"16px"},
                      key: index
                    }, [
                      _createVNode(_unref(BaseCheckbox), {
                        onChange: 
                e => {
                  clearCheck(e, index, 'basicList');
                }
              ,
                        value: 'basic' + item.prop,
                        label: 'basic' + item.prop
                      }, null, 8, ["onChange", "value", "label"]),
                      (
                item.dataType === 1 ||
                item.dataType === 4 ||
                item.dataType === 5
              )
                        ? (_openBlock(), _createBlock(_unref(BaseTooltip), {
                            key: 0,
                            class: "item",
                            effect: "dark",
                            content: item.label,
                            placement: "top",
                            disabled: item.label.length < 21
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(BaseInput), {
                                style: {"width":"350px"},
                                placeholder: item.label,
                                modelValue: item.conditionKey,
                                "onUpdate:modelValue": ($event: any) => ((item.conditionKey) = $event),
                                disabled: 
                  !checkedBasic.value.includes('basic' + item.prop) ||
                  item.disable === 1
                
                              }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue", "disabled"])
                            ]),
                            _: 2
                          }, 1032, ["content", "disabled"]))
                        : (item.dataType === 2)
                          ? (_openBlock(), _createBlock(_unref(BaseDatePicker), {
                              key: 1,
                              modelValue: item.conditionKey,
                              "onUpdate:modelValue": ($event: any) => ((item.conditionKey) = $event),
                              type: "daterange",
                              "start-placeholder": item.label + '起',
                              "end-placeholder": item.label + '止',
                              disabled: !checkedBasic.value.includes('basic' + item.prop)
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "start-placeholder", "end-placeholder", "disabled"]))
                          : (item.dataType === 6)
                            ? (_openBlock(), _createBlock(_unref(BaseDatePicker), {
                                key: 2,
                                modelValue: item.conditionKey,
                                "onUpdate:modelValue": ($event: any) => ((item.conditionKey) = $event),
                                type: "monthrange",
                                "range-separator": "至",
                                "start-placeholder": item.label + '起',
                                "end-placeholder": item.label + '止',
                                disabled: !checkedBasic.value.includes('basic' + item.prop)
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "start-placeholder", "end-placeholder", "disabled"]))
                            : ([3, 7].includes(item.dataType))
                              ? (_openBlock(), _createBlock(_unref(BaseTooltip), {
                                  key: 3,
                                  class: "item",
                                  effect: "dark",
                                  content: item.label,
                                  placement: "top",
                                  disabled: item.label.length < 21
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(BaseSelect), {
                                      modelValue: item.conditionKey,
                                      "onUpdate:modelValue": ($event: any) => ((item.conditionKey) = $event),
                                      clearable: "",
                                      filterable: "",
                                      "collapse-tags": "",
                                      placeholder: item.label,
                                      disabled: !checkedBasic.value.includes('basic' + item.prop),
                                      options: item.options
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "disabled", "options"])
                                  ]),
                                  _: 2
                                }, 1032, ["content", "disabled"]))
                              : _createCommentVNode("", true),
                      (item.dataType === 31)
                        ? (_openBlock(), _createBlock(_unref(BaseTooltip), {
                            key: 4,
                            class: "item",
                            effect: "dark",
                            content: item.label,
                            placement: "top",
                            disabled: item.label.length < 21
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(BaseAutocomplete), {
                                placeholder: item.label,
                                modelValue: item.conditionKey,
                                "onUpdate:modelValue": ($event: any) => ((item.conditionKey) = $event),
                                maxlength: 30,
                                "fetch-suggestions": 
                  (queryString, cb) => {
                    cb(
                      item.options.filter(
                        i => !queryString || i.value?.indexOf(queryString) > -1
                      )
                    );
                  }
                ,
                                onSelect: 
                  item => {
                    item.conditionKey = item.value;
                  }
                ,
                                disabled: 
                  !checkedBasic.value.includes('basic' + item.prop) ||
                  item.disable === 1
                
                              }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue", "fetch-suggestions", "onSelect", "disabled"])
                            ]),
                            _: 2
                          }, 1032, ["content", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_unref(BaseCol), { span: 12 }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(BaseCheckbox), {
                  modelValue: other.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((other).value = $event)),
                  onChange: otherCheckAll
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 全选 ")
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createVNode(_unref(BaseCheckboxGroup), {
                modelValue: checkedOther.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((checkedOther).value = $event)),
                onChange: otherChecked
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      style: {"display":"flex","align-items":"center","margin-bottom":"16px"},
                      key: index
                    }, [
                      ([5, 20].includes(+_ctx.projectType))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(index + 1), 1))
                        : _createCommentVNode("", true),
                      _createVNode(_unref(BaseCheckbox), {
                        onChange: 
                e => {
                  clearCheck(e, index, 'otherList');
                }
              ,
                        value: 'other' + item.prop,
                        label: 'other' + item.prop
                      }, null, 8, ["onChange", "value", "label"]),
                      (
                item.dataType === 1 ||
                item.dataType === 4 ||
                item.dataType === 5 ||
                item.dataType === 9
              )
                        ? (_openBlock(), _createBlock(_unref(BaseTooltip), {
                            key: 1,
                            class: "item",
                            effect: "dark",
                            content: item.label,
                            placement: "top",
                            disabled: item.label.length < 21
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(BaseInput), {
                                style: {"width":"350px"},
                                placeholder: item.label,
                                modelValue: item.conditionKey,
                                "onUpdate:modelValue": ($event: any) => ((item.conditionKey) = $event),
                                disabled: 
                  !checkedOther.value.includes('other' + item.prop) ||
                  item.disable === 1
                
                              }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue", "disabled"])
                            ]),
                            _: 2
                          }, 1032, ["content", "disabled"]))
                        : (item.dataType === 8)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _createVNode(_unref(BaseTooltip), {
                                class: "item",
                                effect: "dark",
                                content: item.label,
                                placement: "top",
                                disabled: item.label.length < 8
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(BaseInput), {
                                    style: {"width":"150px"},
                                    placeholder: item.label,
                                    modelValue: item.conditionKey[0],
                                    "onUpdate:modelValue": ($event: any) => ((item.conditionKey[0]) = $event),
                                    onFocus: ($event: any) => (
                    item.conditionKey = Array.isArray(item.conditionKey)
                      ? item.conditionKey
                      : ['', '']
                  ),
                                    onInput: 
                    e => {
                      item.conditionKey[0] = limitToNum(e);
                    }
                  ,
                                    disabled: 
                    !checkedOther.value.includes('other' + item.prop) ||
                    item.disable === 1
                  
                                  }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue", "onFocus", "onInput", "disabled"])
                                ]),
                                _: 2
                              }, 1032, ["content", "disabled"]),
                              _hoisted_7,
                              _createVNode(_unref(BaseTooltip), {
                                class: "item",
                                effect: "dark",
                                content: item.label,
                                placement: "top",
                                disabled: item.label.length < 8
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(BaseInput), {
                                    style: {"width":"150px"},
                                    placeholder: item.label,
                                    modelValue: item.conditionKey[1],
                                    "onUpdate:modelValue": ($event: any) => ((item.conditionKey[1]) = $event),
                                    onFocus: ($event: any) => (
                    item.conditionKey = Array.isArray(item.conditionKey)
                      ? item.conditionKey
                      : ['', '']
                  ),
                                    onInput: 
                    e => {
                      item.conditionKey[1] = limitToNum(e);
                    }
                  ,
                                    disabled: 
                    !checkedOther.value.includes('other' + item.prop) ||
                    item.disable === 1
                  
                                  }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue", "onFocus", "onInput", "disabled"])
                                ]),
                                _: 2
                              }, 1032, ["content", "disabled"])
                            ]))
                          : (
                item.dataType === 2 ||
                item.dataType === 6 ||
                item.dataType === 18
              )
                            ? (_openBlock(), _createBlock(_unref(BaseTooltip), {
                                key: 3,
                                class: "item",
                                effect: "dark",
                                content: item.label,
                                placement: "top",
                                disabled: item.label.length < 8
                              }, {
                                default: _withCtx(() => [
                                  (item.dataType === 2)
                                    ? (_openBlock(), _createBlock(_unref(BaseDatePicker), {
                                        key: 0,
                                        modelValue: item.conditionKey,
                                        "onUpdate:modelValue": ($event: any) => ((item.conditionKey) = $event),
                                        type: "daterange",
                                        "value-format": "YYYY-MM-DD",
                                        "range-separator": "至",
                                        "start-placeholder": item.label + '起',
                                        "end-placeholder": item.label + '止',
                                        disabled: !checkedOther.value.includes('other' + item.prop)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "start-placeholder", "end-placeholder", "disabled"]))
                                    : _createCommentVNode("", true),
                                  (item.dataType === 18)
                                    ? (_openBlock(), _createBlock(_unref(BaseDatePicker), {
                                        key: 1,
                                        modelValue: item.conditionKey,
                                        "onUpdate:modelValue": ($event: any) => ((item.conditionKey) = $event),
                                        type: "daterange",
                                        "value-format": "YYYY-MM-DD",
                                        "range-separator": "至",
                                        "start-placeholder": item.label + '起',
                                        "end-placeholder": item.label + '止',
                                        disabled: !checkedOther.value.includes('other' + item.prop)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "start-placeholder", "end-placeholder", "disabled"]))
                                    : (item.dataType === 6)
                                      ? (_openBlock(), _createBlock(_unref(BaseDatePicker), {
                                          key: 2,
                                          modelValue: item.conditionKey,
                                          "onUpdate:modelValue": ($event: any) => ((item.conditionKey) = $event),
                                          style: {"width":"350px"},
                                          type: "monthrange",
                                          "value-format": "YYYY-MM",
                                          "range-separator": "至",
                                          "start-placeholder": item.label + '起',
                                          "end-placeholder": item.label + '止',
                                          disabled: !checkedOther.value.includes('other' + item.prop)
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "start-placeholder", "end-placeholder", "disabled"]))
                                      : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["content", "disabled"]))
                            : (item.dataType === 3 || item.dataType === 7)
                              ? (_openBlock(), _createBlock(_unref(BaseTooltip), {
                                  key: 4,
                                  class: "item",
                                  effect: "dark",
                                  content: item.label,
                                  placement: "top",
                                  disabled: item.label.length < 21
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(BaseSelect), {
                                      style: {"width":"350px"},
                                      modelValue: item.conditionKey,
                                      "onUpdate:modelValue": ($event: any) => ((item.conditionKey) = $event),
                                      clearable: "",
                                      placeholder: item.label,
                                      disabled: !checkedOther.value.includes('other' + item.prop),
                                      options: 
                  item.options.map(citem => {
                    return {
                      label: citem.label ? citem.label : citem,
                      value: citem.value ? citem.value : citem
                    };
                  })
                
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "disabled", "options"])
                                  ]),
                                  _: 2
                                }, 1032, ["content", "disabled"]))
                              : (item.dataType === 17)
                                ? (_openBlock(), _createBlock(_unref(BaseTooltip), {
                                    key: 5,
                                    class: "item",
                                    effect: "dark",
                                    content: item.label,
                                    placement: "top",
                                    disabled: item.label.length < 21
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(BaseCascader), {
                                        style: {"width":"350px"},
                                        modelValue: item.conditionKey,
                                        "onUpdate:modelValue": ($event: any) => ((item.conditionKey) = $event),
                                        clearable: "",
                                        placeholder: item.label,
                                        disabled: !checkedOther.value.includes('other' + item.prop),
                                        options: item.options
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "disabled", "options"])
                                    ]),
                                    _: 2
                                  }, 1032, ["content", "disabled"]))
                                : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_unref(BaseAlert), {
            title: "注：选择相应的字段后，将会在列表显示",
            type: "warning",
            closable: false,
            "show-icon": ""
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["before-close"]))
}
}

})